import { render } from "./SuccessfulDeliveriesCsvReport.vue?vue&type=template&id=18c82fd2&ts=true&lang=pug"
import script from "./SuccessfulDeliveriesCsvReport.vue?vue&type=script&lang=ts"
export * from "./SuccessfulDeliveriesCsvReport.vue?vue&type=script&lang=ts"

import "./SuccessfulDeliveriesCsvReport.vue?vue&type=style&index=0&id=18c82fd2&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__